import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LookupImage } from '../../../core/models/product-lookup';

/**
 * Lớp xem ảnh sản phẩm phóng to.
 *
 * Dùng chung cho màn Tra cứu và màn POS — hai chỗ đều cần đối chiếu đúng màu
 * hàng trên kệ, mà mỗi màn một bản thì sớm muộn lệch nhau.
 *
 * Màn cha điều khiển đóng/mở bằng `*ngIf` và tự quyết mở ở tấm nào: mở đúng
 * tấm đang hiện trên thẻ chứ không phải tấm đầu thư viện.
 */
@Component({
  selector: 'app-image-zoom',
  templateUrl: './image-zoom.component.html',
  styleUrls: ['./image-zoom.component.scss'],
})
export class ImageZoomComponent {

  @Input() images: LookupImage[] = [];
  @Input() title = '';

  /** Tấm mở ra đầu tiên. */
  @Input() set index(value: number) {
    this.current = Number(value || 0);
  }

  @Output() closed = new EventEmitter<void>();

  current = 0;

  get image(): LookupImage | null {
    return this.images[this.current] || null;
  }

  close() {
    this.closed.emit();
  }

  /** Lật ảnh, chạy vòng để lướt tới cuối không bị kẹt. */
  step(delta: number, ev: Event) {
    ev.stopPropagation();
    const n = this.images.length;
    if (n < 2) return;
    this.current = (this.current + delta + n) % n;
  }

  stop(ev: Event) {
    ev.stopPropagation();
  }
}
